import type { ModuleProgressInfo } from "@/components/dashboard/ModuleRow";

const moduleStatusFromProgress = (
  progressPercent: number
): ModuleProgressInfo["status"] => {
  if (progressPercent >= 100) return "completed";
  if (progressPercent > 0) return "in_progress";
  return "not_started";
};

export { moduleStatusFromProgress };
